import React from 'react';
import propTypes from 'prop-types';
import { returnStatusLabel } from './returnSale';

const ReturnStatus = ({ sale }) => {
  const label = returnStatusLabel(sale);
  return (
    <>
      <div>{label || sale.status || '-'}</div>
      {label && sale.status ? <div style={{ fontSize: '.75rem' }}>{sale.status}</div> : null}
    </>
  );
};

ReturnStatus.propTypes = { sale: propTypes.object.isRequired };

export default ReturnStatus;
